import {AppLocalStorage} from "@services/utils";

export default function () {
  return {
    user: JSON.parse(AppLocalStorage.getItem('csAuth.user')),
    token: AppLocalStorage.getItem('csAuth.token'),
    expire_time: Number(AppLocalStorage.getItem('csAuth.expire_time'))
  }
}
